import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Breadcrumb from "~/components/desktop/atoms/Breadcrumb";

const AuthenticationMedpro = ({
  ChildComponent,
  IsAuthenticated,
  breadcrumb,
  isMigrating,
  ...rest
}) => {
  if (isMigrating) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh"
        }}
      >
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  // if (!IsAuthenticated) {
  //   return <Redirect to="/login" />;
  // }

  return (
    <Fragment>
      {breadcrumb && <Breadcrumb className="head" />}
      <ChildComponent {...rest} IsAuthenticated={IsAuthenticated} />
    </Fragment>
  );
};

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated }
  } = state;
  return {
    IsAuthenticated
  };
};

export default connect(mapStateToProps)(AuthenticationMedpro);
